import React from 'react'
import { Outlet } from 'react-router-dom'

import { Footer } from '../Footer'

export const Main: React.FC = () => {
  return (
    <div className="layout-main flex flex-column justify-content-between align-content-between">
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
